"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanFilter = booleanFilter;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const BaseFilter_1 = require("./BaseFilter");
const SelectField_1 = require("../../inputs/SelectField");
function booleanFilter(props) {
    return (key) => new BooleanFilter(key, props);
}
class BooleanFilter extends BaseFilter_1.BaseFilter {
    render(value, setValue, tid, inModal, vertical) {
        // Our options are a list of tuples
        const { options = defaultBooleanOptions, label, defaultValue, ...props } = this.props;
        return ((0, jsx_runtime_1.jsx)(SelectField_1.SelectField, { ...props, compact: !vertical, label: this.label, 
            // We use `String(value)` so that `undefined` becomes "undefined"
            value: String(value), labelStyle: inModal ? "hidden" : !inModal && !vertical ? "inline" : "above", sizeToContent: !inModal && !vertical, options: options, getOptionValue: (o) => String(o[0]), getOptionLabel: (o) => o[1], onSelect: (value) => {
                // Change our string "true" / "false" / "undefined" back to boolean | undefined
                const parsedValue = value === "undefined" ? undefined : value === "true";
                setValue(parsedValue);
            }, ...this.testId(tid) }));
    }
}
const defaultBooleanOptions = [
    [undefined, "Any"],
    [true, "Yes"],
    [false, "No"],
];
